const textFieldModalEquipServQuest = {
  name: 'Pregunta',
  description: 'Detalle de la pregunta *',
  helperText: '* El propósito de este campo es ayudar al ejecutor a responder correctamente esta pregunta.'
};

export default textFieldModalEquipServQuest;
